export const transactionTitles = {
  "transfer-sent": "Oordrag gestuur",
  "transfer-received": "Oordrag ontvang",
  withdrawal: "Onttrekking",
  deposit: "Deposito",
  "parley-rebate": "Parley 10% kontantterug",
  "morning-promotion-award": "Oggenddeposito-promosie",
  "betby-bet": "Betby - Weddenskap verloor",
  "betby-win": "Betby - Weddenskap gewen",
  "betby-refund": "Betby - Weddenskap terugbetaal",
  "pixmove-bet": "Pixmove - Weddenskap verloor",
  "pixmove-win": "Pixmove - Weddenskap gewen",
  "pixmove-rollback": "Pixmove - Weddenskap terugbetaal",
  "pragmatic-bet": "Pragmatic - Weddenskap verloor",
  "pragmatic-win": "Pragmatic - Weddenskap gewen",
  "pragmatic-refund": "Pragmatic - Weddenskap terugbetaal",
  "hacksaw-rollback": "Hacksaw - Weddenskap terugbetaal",
  "hacksaw-win": "Hacksaw - Weddenskap gewen",
  "hacksaw-bet": "Hacksaw - Weddenskap verloor",
  "kaga-win": "Kaga - Weddenskap gewen",
  "kaga-bet": "Kaga - Weddenskap verloor",
  "gamingcorps-bet": "Gamingcorps - Weddenskap verloor",
  "gamingcorps-win": "Gamingcorps - Weddenskap gewen",
  "gamingcorps-refund": "Gamingcorps - Weddenskap terugbetaal",
  "bgaming-lost": "BGaming - Weddenskap verloor",
  "bgaming-win": "BGaming - Weddenskap gewen",
  "bgaming-bet": "BGaming - Weddenskap verloor",
  "bgaming-refund": "BGaming - Weddenskap terugbetaal",
  "upgaming-bet": "Upgaming - Weddenskap verloor",
  "upgaming-win": "Upgaming - Weddenskap gewen",
  "upgaming-lost": "Upgaming - Weddenskap verloor",
  "upgaming-refund": "Upgaming - Weddenskap terugbetaal",
  "timeless-bet": "Timeless - Weddenskap verloor",
  "timeless-win": "Timeless - Weddenskap gewen",
  "timeless-refund": "Timeless - Weddenskap terugbetaal",
  "pragmatic-adjustment": "Pragmatic - Aanpassing",
  "lottery-ticket-purchase": "Loterykaartjie gekoop",
  "lottery-winnings": "Loterywinste",
};
